module.exports = __webpack_public_path__ + "img/topicLeisure.deb4627f.svg";